import React from "react";
import { Navigate } from "react-router-dom";
import useSessionStore from "../../state/session";
import GuestMfaSettings from "../../components/auth/GuestMfaSettings";
export default function GuestAccountSecurityPage() {
  const level = useSessionStore((state) => state.securityLevel);
  if (level !== "guest") return <Navigate to="/profile/edit" replace />;
  return (
    <main
      className="stack gap-md"
      style={{ maxWidth: 680, margin: "32px auto", padding: 20 }}
    >
      <h1>Guest account security</h1>
      <div className="settings-card">
        <div className="settings-card__body">
          <GuestMfaSettings />
        </div>
      </div>
    </main>
  );
}
